import { Component, HostBinding, Input } from '@angular/core'
import { Navigation } from '@shared/models/navigation.model'

@Component({
  selector: 'lin-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  standalone: false,
})
export class NavItemComponent {
  @HostBinding('class') classes = 'nav-item'
  @Input() navItem: Navigation

  openLink(link: string): void {
    window.open(link, '_blank', 'noopener')
  }
}
